export function AuthErrorAlert({ message }: { message: string }) {
    return (
        <p
            role="alert"
            className="rounded-nested bg-destructive/8 px-4 py-3 text-sm font-medium leading-5 text-destructive"
        >
            {message}
        </p>
    );
}
